import { Text } from '@doordash/design-language';
import { Waypoint } from 'react-waypoint';
import { TitleWrapper } from 'top-component-library/HalfSheetModal/styles';
import { TODO } from 'utils/Types';
import { Description, LowStockNote, MainHeader, StyledTitle } from '../styles';

export const WaypointContent = ({
  isMobile,
  menuItem,
  modalTitleRef,
  setShowFixedHeader,
}: {
  isMobile: boolean;
  menuItem: TODO;
  modalTitleRef: React.RefObject<HTMLDivElement>;
  setShowFixedHeader: (value: boolean) => void;
}) =>
  menuItem ? (
    <Waypoint
      key={String(isMobile) /* if isMobile changes, reset the component */}
      onEnter={() => setShowFixedHeader(false)}
      onLeave={({ currentPosition }) => {
        if (currentPosition === 'above') {
          setShowFixedHeader(true);
        }
      }}
    >
      <div>
        <MainHeader hasImage={menuItem.imageUrl}>
          <div>
            <TitleWrapper
              // Need to set ref to wrapper because <Text/> doesn't accept the ref attr
              ref={modalTitleRef}
              tabIndex={0}
              aria-label={menuItem.name_for_customer}
              role="heading"
              aria-level={1}
            >
              <StyledTitle styles={Text.Styles.Medium24}>{menuItem.name_for_customer}</StyledTitle>
            </TitleWrapper>
            {!!menuItem.description && <Description>{menuItem.description}</Description>}
            {menuItem.isLowStock && <LowStockNote>Only a few left!</LowStockNote>}
          </div>
        </MainHeader>
      </div>
    </Waypoint>
  ) : null;
